module.exports = __webpack_public_path__ + "img/pic_coinstore_happyx2@3x.b89aeb09.png";